module.exports = __webpack_public_path__ + "static/media/pest_life_cycle.3e3cf5b3.png";